<template>
	<div>
		<div class="content" >
			<div class="content-title" >
				<div class="title1" >{{miaoshu1}}</div>
				<div class="title2">{{miaoshu2}}</div>
			</div>
			<div class="imgLsit">
				<img class="empty" src = "../../static/images/order/1.png" alt = "">
				<img class="program" :src = "QRcode" alt = "">
				<img class="app" :src = "downcode" alt = "">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "empty",
	data() {
		return {
			downcode: window.localStorage.getItem("downcode"),
			QRcode: window.localStorage.getItem("QRcode"),
			miaoshu1: 'PC端功能已全面下线！',
			miaoshu2: '您可在自营APP(小程序)中查看浏览'
		}
	},
	created() {
		this.getdata()
	},
	methods: {
		getdata() {
			this.$http({
				url: this.$http.adornUrl('/common/type/286'),	//pc端下线功能描述标题
				method: 'get',
			}).then(({data}) => {
				window.localStorage.setItem("QRcode",data.data.value);
				this.miaoshu1 = data.data.value
			})
			this.$http({
				url: this.$http.adornUrl('/common/type/287'),	//pc端下线功能描述内容
				method: 'get',
			}).then(({data}) => {
				window.localStorage.setItem("QRcode",data.data.value);
				this.miaoshu2 = data.data.value
			})
		}
	}

}
</script>

<style scoped>
.content {
	width: 900px;
	margin: 0 auto;
	padding: 40px 20px;
	background: #fff;
}
.content-title {
	margin: 30px;
}
.title1 {
	font-size: 34px;
	font-weight: 700;
	color: #333333;
}
.title2 {
	font-size: 20px;
	font-weight: 400;
	color: #333333;
	margin-top: 20px;
}
.imgLsit {
	display: flex;
	justify-content: space-between;
}
.empty {
	width: 527px;
	height: 425px;
}
.program,.app {
	width: 160px;
	height: 160px;
	margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/empty.vue